import { CHAT_CONTACT_EMAIL } from '@/lib/chat-contact';
import { CHAT_LINK_TTL_HOURS } from '@matter_extractor/shared';

/**
 * The dead link, S8 (chat spec §3, §5).
 *
 * It takes NO props, and that is the requirement rather than an economy: an
 * expired link and a link that never existed render the SAME screen (§5), so
 * this component must have nothing to tell them apart with. A prop naming which
 * case it is would be a probe - somebody sounding out tokens would learn which
 * ones exist - and it would eventually be rendered.
 *
 * **It is the screen of the 410 and of nothing else.** `isChatLinkGone` only
 * returns true on a 410, and `chat.$token.tsx` sends everything else to
 * `ChatUnavailable`. That separation is load-bearing in this direction too: a
 * 429 from the per-address ceiling, a dropped connection or a schema parse that
 * failed must NOT land here, because this screen is a one-way door in the UI -
 * which is why it deliberately offers **no retry**. There is nothing to retry:
 * the answer is final, and a button here would invite somebody holding a dead
 * link to keep pressing it. `ChatUnavailable` carries the retry, and the two
 * screens exist precisely so that one of them can.
 *
 * The wording says the RULE and not the verdict on this token - « les liens
 * expirent 24 heures après la création » - which is how it can be true for both
 * cases it serves without telling the reader which one she is in.
 */
export function ChatExpired() {
  return (
    <section data-testid="chat-expired" className="mx-auto max-w-xl space-y-6 px-5 py-12">
      <div className="space-y-2">
        <h1 className="font-semibold text-h3 text-bleu-nuit">Ce lien n’est plus valable</h1>
        <p className="text-body text-gray-700">
          {/* Read from the shared constant rather than typed out: the lobby says
              the same number, and two spellings of a promise diverge. */}
          Les liens d’entretien expirent {CHAT_LINK_TTL_HOURS} heures après la création de la salle.
          Demandez un nouveau lien à la personne qui vous a invité.
        </p>
      </div>

      <p className="text-gray-600 text-small">
        Une question sur un entretien déjà passé ?{' '}
        <a href={`mailto:${CHAT_CONTACT_EMAIL}`} className="text-bleu-nuit underline">
          {CHAT_CONTACT_EMAIL}
        </a>
      </p>
    </section>
  );
}
